import {Routes, RouterModule, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild} from '@angular/router';
import {SiteLayoutComponent} from './layouts/site-layout/site-layout.component';
import {HomeComponent} from './pages/home/home.component';
import {AppLayoutComponent} from './layouts/app-layout/app-layout.component';
import {LoginPageComponent} from './pages/login-page/login-page.component';
import {NotFoundPageComponent} from './pages/not-found-page/not-found-page.component';
import {RoomGroupPageComponent} from './pages/room-group-page/room-group-page.component';
import {UserPageComponent} from './pages/user-page/user-page.component';
import {LogoutPageComponent} from './pages/logout-page/logout-page.component';
import {Injectable} from '@angular/core';
import {SharedValueService} from './services/shared-value.service';
import {PreLoginService} from './services/pre-login.service';
import {HistoryBookingPageComponent} from './pages/history-booking-page/history-booking-page.component';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate, CanActivateChild {
  constructor(private sharedValue: SharedValueService,
              private preLogin: PreLoginService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.preLogin.canActiveAuthority('auth', state.url);
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.preLogin.canActiveAuthority('admin', state.url);
  }
}


const appRoutes: Routes = [

  // Site routes goes here
  {
    path: '',
    component: SiteLayoutComponent,
    canActivate: [CanActivateViaAuthGuard],
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full'},
      { path: 'admin',
        canActivateChild: [CanActivateViaAuthGuard],
        children: [
          { path: 'room_group_site', component: RoomGroupPageComponent },
          { path: 'user', component: UserPageComponent},
          { path: 'history_booking', component: HistoryBookingPageComponent}
        ]
      },
    ],
  },

  // App routes goes here here
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: 'NotFound', component: NotFoundPageComponent }
    ]
  },
  // no layout routes
  { path: 'login', component: LoginPageComponent},
  { path: 'logout', component: LogoutPageComponent},
  { path: 'password/reset/:token', component: LoginPageComponent},

  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const AppRouting = RouterModule.forRoot(appRoutes);





// WEBPACK FOOTER //
// /app/src/app/app.routing.ts